type formsPlural = 'one' | 'few' | 'many';

export const getPluralized = (count: number, forms: Record<formsPlural, string>) => {
    const absCount = Math.abs(count) % 100;
    const lastDigit = absCount % 10;

    if (absCount > 10 && absCount < 20) {
        return `${count} ${forms.many}`;
    }
    if (lastDigit > 1 && lastDigit < 5) {
        return `${count} ${forms.few}`;
    }

    if (lastDigit === 1) {
        return `${count} ${forms.one}`;
    }

    return `${count} ${forms.many}`;
};
